import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/lampp/htdocs/maha6v2/app/[locale]/(auth)/component/auth-header.tsx");
